import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net'; 
import 'datatables.net-dt/css/dataTables.dataTables.css'; 
import raw from '../../../../images/raw_material/else.jpg';
import rice from '../../../../images/raw_material/rice.png';
import black_sesame from '../../../../images/raw_material/black_sesame.png';
import chana_dal from '../../../../images/raw_material/chana_dal.png';
import dhalimage from '../../../../images/raw_material/dhal.png';
import tomatoimage from '../../../../images/raw_material/tomato.png';
import cumin_seeds_powder from '../../../../images/raw_material/cumin_seeds_powder.png';
import fenugreek from '../../../../images/raw_material/fenugreek.png';
import hing from '../../../../images/raw_material/hing.png';
import red_chilly from '../../../../images/raw_material/red_chilly.png';
import oil from '../../../../images/raw_material/oil.png';
import salt from '../../../../images/raw_material/salt.png';
import urad_dal from '../../../../images/raw_material/urad_dal.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import Drawer from '@mui/material/Drawer';
import AddRawMat from '../../../modal/Purchase_Management/Manage_Raw_Material/Raw_Material_Add';
import EditRawMat from '../../../modal/Purchase_Management/Manage_Raw_Material/Raw_Material_Edit';
import ViewRawMat from '../../../modal/Purchase_Management/Manage_Raw_Material/Raw_Material_View';
import Raw_Material_View from '../../../modal/Purchase_Management/Manage_Raw_Material/Raw_Material_View';
import Raw_Material_Edit from '../../../modal/Purchase_Management/Manage_Raw_Material/Raw_Material_Edit';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
    
const RawMaterials = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [rawMaterials, setRawMaterials] = useState([]); // raw materials data
    const [hasFetched, setHasFetched] = useState(false);
    const [page, setPage] = useState(1); // pagination
    const [totalPages, setTotalPages] = useState(1); // pagination 
    const [searchTerm, setSearchTerm] = useState(''); // pagination    
    const [perPage, setPerPage] = useState(25); // pagination
 
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

// const fetchData = async (pageNumber = page, perPageCount = perPage, search = searchTerm) => {
//     setHasFetched(false);
//     try {
//         const response = await axios.get(`${baseURL}/raw-materials`, {
//             params: {
//                 page: pageNumber,
//                 per_page: perPageCount,
//                 search: search,
//                 // branch_id: branch_id,   // ✅ send branch_id
//             }
//         });

//         const data = response.data;

//         setRawMaterials(data.data || []); 
//         setTotalPages(data.pagination?.last_page || 1); 
//         setHasFetched(true);
//     } catch (error) {
//         console.error('Error fetching raw materials:', error);

//         setHasFetched(true);
//         setRawMaterials([]);
//         setTotalPages(1);
//     }
// };

// Fetch data on page change, perPage change, or search term change

const fetchData = async (pageNumber = page, perPageCount = perPage, search = searchTerm) => {
    
    setLoading(true);   // Start loader
    try {
        const response = await axios.get(`${baseURL}/raw-materials`, {
            params: {
                page: pageNumber,
                per_page: perPageCount,
                search: search,
            }
        });

        const data = response.data;

        setRawMaterials(data.data || []);
        setTotalPages(data.pagination?.last_page || 1);

    } catch (error) {
        console.error('Error fetching raw materials:', error);
        setRawMaterials([]);
        setTotalPages(1);
    } finally {
        setLoading(false);  // Stop loader
    }
};



useEffect(() => {
    fetchData(page, perPage, searchTerm);
}, [page, perPage, searchTerm]);



    // Pagination handler (for next/previous buttons or page change)
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    // Refresh data when search term is changed
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setPage(1); // Reset to page 1 when search term changes
    };

    // Example for soft refresh
    const softRefresh = () => {
        setHasFetched(false);
        fetchData(1, perPage, searchTerm); // Reset to page 1
    };

    const handleRawMaterialStatusChange = (rawMaterialId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
    
        axios.post(`${baseURL}/raw-materials/${rawMaterialId}/status`, { status: newStatus })
            .then(() => {
                fetchData(); // This should refresh the vendor list
            })
            .catch(error => {
                console.error("Error updating Raw Materials status:", error);
            }); 
        };
 
    
    // For View(Start)
    const [viewRawMaterialDetails, setViewRawMaterialDetails] = useState(null);
    
    const handleModalToggleView = (rawMaterialId) => { 
    // setLoading(true);
    axios.get(`${baseURL}/raw-materials/${rawMaterialId}`)
        .then(response => {
            setViewRawMaterialDetails(response.data.data);
            setModalType("ViewRawMat");
            setOpen(true);
        })
        .catch(error => {
            console.error("Error fetching raw material details:", error);
        })
        .finally(() => {
            // setLoading(false);
        });
    };
    // For View(End)
        

         // edit start
         
                const [showEditModal, setShowEditModal] = useState(false);  // Controls modal visibility
                const [rawmaterialIdToEdit, setrawmaterialIdToEdit] = useState(null); 
                const [rawmaterialData, setrawmaterialData] = useState({});
                const handleModalToggleEdit = (rawmaterialId) => {
                    setrawmaterialIdToEdit(rawmaterialId);  // Set the product ID to edit 
                    setShowEditModal(true);         // Show the modal
                }; 
                // Function to close the modal
                const handleCloseModal = () => {
                    setShowEditModal(false);
                    setrawmaterialIdToEdit(null);  // Reset product ID when modal is closed
                };
            
                useEffect(() => {
                    if (rawmaterialIdToEdit) {
                        // Fetch the product data based on the productId (sno) when the modal is shown
                        const fetchVendors = async () => {
                            try {
                                // setLoading(true);
                                const response = await axios.get(`${baseURL}/raw-materials/${rawmaterialIdToEdit}`);
                                if (response.data) {
                                    setrawmaterialData(response.data.data);
                                }
                            } catch (error) {
                                console.error("Error fetching raw material data:", error);
                            } finally {
                                // setLoading(false);
                            }
                        };
                        fetchVendors();
                    }
                }, [rawmaterialIdToEdit]); 
        
            // edit end
    const [filterOpen, setFilterOpen] = useState(false);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const [open, setOpen] = useState(false); // Modal visibility state
    const [modalType, setModalType] = useState("");

    const handleModalToggle = () => {
        setModalType("AddRawMat");  // Set the modal type to "Add"
        setOpen(true);  // Toggle the modal visibility
    };
    const handleModalToggle_Edit = () => {
        setModalType("EditRawMat");  // Set the modal type to "Add"
        setOpen(true);
    };
    const handleModalToggle_View = () => {
        setModalType("ViewRawMat");  // Set the modal type to "Add"
        setOpen(true);
    };
    const tableRef = useRef(null);
    const onClose = () => {
        setFilterOpen(false); 
    };

    const raw_material_cat = [
        { value: "all", label: "All" },
        { value: "1", label: "Grains" },
        { value: "2", label: "vegetables" },
    ];
 
    const raw_material = [
        { value: "all", label: "All" },
        { value: "1", label: "Ponni Rice" },
        { value: "2", label: "Dhal" },
        { value: "3", label: "Tomato" },
        { value: "4", label: "Urad Dhal" },
        { value: "5", label: "Fenugreek" },
        { value: "6", label: "Nice Salt" },
    ];
    const vendor_cat = [
        { value: "all", label: "All" },
        { value: "1", label: "Vegetable Shop" },
        { value: "2", label: "Grocery Shop" },
    ];
    const vendor = [
        { value: "all", label: "All" },
        { value: "1", label: "Kannan Vegetable Shop" },
        { value: "2", label: "Krishnan Vegetable Shop" },
        { value: "3", label: "Reliance Mart" }
    ];
    const [selectedOption, setSelectedOption] = useState(null);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());


    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];
  
    const [loading, setLoading] = useState(false);

    useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
    }, []);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                  
                    {loading ? (
                    <>
                        <div className="mb-0 px-0">
                        <h4 className="text-primary fw-bold">
                            <Skeleton width={150} height={20} />
                        </h4>
                        </div>

                        <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Skeleton width={75} height={14} /></li>
                        <li className="breadcrumb-item"><Skeleton width={75} height={14} /></li>
                        <li className="breadcrumb-item active"><Skeleton width={75} height={14} /></li>
                        </ol>
                    </>
                    ) : (
                    <>
                        <div className="mb-0 px-0">
                        <h4 className="text-primary fw-bold">Manage Raw Material</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Purchase Management</li>
                        </ol>
                    </>
                    )}
                                
                </div>
                {/* <div className='d-flex align-items-center gap-3 mb-2'>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                    <Button
                        className="btn btn-primary btn-sm"
                        onClick={handleModalToggle}
                    >
                        <span className="me-2">
                            <i className="fa-solid fa-plus fs-8"></i>
                        </span>
                        <span>Add Raw Material</span>
                    </Button>
                    {open && modalType === "AddRawMat" && (
                        <AddRawMat show={open} onClose={() => setOpen(false)} />
                    )}
                    {open && modalType === "EditRawMat" && (
                        <EditRawMat show={open} onClose={() => setOpen(false)} />
                    )}
                    {open && modalType === "ViewRawMat" && (
                        <ViewRawMat show={open} onClose={() => setOpen(false)} />
                    )} 
                </div> */}
                <div className='d-flex align-items-center gap-3 mb-2'>
                    {loading ? (
                        <>
                            <Skeleton width={80} height={32} />
                            <Skeleton width={130} height={32} />
                        </>
                    ) : (
                        <>
                            <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                                <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                                <span>Filter</span>
                            </Link>

                            <Button
                                className="btn btn-primary btn-sm"
                                onClick={handleModalToggle}
                            >
                                <span className="me-2">
                                    <i className="fa-solid fa-plus fs-8"></i>
                                </span>
                                <span>Add Raw Material</span>
                            </Button>

                            {open && modalType === "AddRawMat" && (
                                <AddRawMat show={open} onClose={() => setOpen(false)} />
                            )}
                            {open && modalType === "EditRawMat" && (
                                <EditRawMat show={open} onClose={() => setOpen(false)} />
                            )}
                            {open && modalType === "ViewRawMat" && (
                                <ViewRawMat show={open} onClose={() => setOpen(false)} />
                            )}
                        </>
                    )}
                </div>

            </div>
            <div className="table-container">

                {/* <div className="d-flex justify-content-between align-items-center mb-3"> 
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={125}>125</option>
                        </select>
                    </div>
 
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div> */}
                                                    
                <div className="d-flex justify-content-between align-items-center mb-3">
    
                    {loading ? (
                        <>
                            {/* LEFT SKELETON */}
                            <div>
                                <Skeleton width={120} height={30} />
                            </div>

                            {/* RIGHT SKELETON */}
                            <div>
                                <Skeleton width={200} height={40} />
                            </div>
                        </>
                    ) : (
                        <>
                            {/* Left: Show entries dropdown */}
                            <div>
                                <label className="me-2">Show</label>
                                <select
                                    className="form-select d-inline w-auto"
                                    style={{ fontSize: '0.85rem', height: '30px' }}
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(Number(e.target.value));
                                        setPage(1);
                                    }}
                                >
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={125}>125</option>
                                </select>
                            </div>

                            {/* Right: Search input */}
                            <div>
                                <input
                                    type="text"
                                    style={{ fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(1);
                                    }}
                                />
                            </div>
                        </>
                    )}

                </div>

                <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    {/* <thead>
                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px text-start'>Raw Material/ Category</th>
                            <th className='min-w-100px'>Brand / Expiry</th>
                            <th className='min-w-50px text-center'>GST</th>
                            <th className='min-w-80px'>Qty / Units</th>
                            <th className='min-w-100px'>Min / Max Stock</th>
                            <th className='min-w-100px'>Base Cost</th> 
                            <th className='min-w-50px'>Status</th>
                            <th className='min-w-80px'>Action</th>
                        </tr>
                    </thead> */}
                    <thead>
                        {loading ? (
                            <tr>
                                <th colSpan="8">
                                    <Skeleton height={25} />
                                </th>
                            </tr>
                        ) : (
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-100px text-start'>Raw Material/ Category</th>
                                <th className='min-w-100px'>Brand / Expiry</th>
                                <th className='min-w-50px text-center'>GST</th>
                                <th className='min-w-80px'>Qty / Units</th>
                                <th className='min-w-100px'>Min / Max Stock</th>
                                <th className='min-w-100px'>Base Cost</th>
                                <th className='min-w-50px'>Status</th>
                                <th className='min-w-80px'>Action</th>
                            </tr>
                        )}
                    </thead>
{/* 
                    <tbody className="text-gray-600 fw-semibold fs-7"> 
                          {Array.isArray(rawMaterials) && rawMaterials.length > 0 ? (
                                            rawMaterials.map(material => (
                        <tr key={material.sno}>
                            <td>
                                <div className="d-flex align-items-center justify-content-start gap-2">
                                    <LightGallery
                                        onInit={onInit}
                                        speed={500}
                                        plugins={[lgThumbnail, lgZoom]}
                                    >
                                        <div data-src={material.image_url || raw} className='border rounded px-1 py-0'>
                                            <img src={material.image_url || raw} alt="Basmathi Rice" className='cursor-pointer w-45px h-45px' />
                                        </div>
                                    </LightGallery>
                                    <div>
                                        <label className='text-black font-w400 fs-7'>{material.rawmaterial_name}</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark">{material.rawmaterial_category_name}</label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w400 fs-7'>  {material.brand_name || <span className="text-muted"> - </span>}</label>
                                <div className='d-block mt-1'>
                                    <Badge bg="info" className='text-white fs-7 py-0 px-1'>{material.expiry_period} Days</Badge>
                                </div>
                            </td>
                            <td className='text-center'>
                                <div className='d-flex flex-row gap-1'>
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Packed GST</span></Tooltip>} >
                                        <Badge bg="success" className='text-white fs-8 py-0 px-1'>{material.packed_gst_value || <span className="text-muted"> - </span>} %</Badge>
                                    </OverlayTrigger>
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Unpacked GST</span></Tooltip>} >
                                        <Badge bg="secondary" className='text-white fs-8 py-0 px-1'>{material.unpacked_gst_value || <span className="text-muted"> - </span>} %</Badge>
                                    </OverlayTrigger>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w400 fs-7'>{material.rawmaterial_quantity} {material.rawmaterial_unit_name}</label>
                            </td>
                            <td>
                                <Badge bg="warning" className='text-white fs-7 py-0 px-1'>Min - {material.minimum_stock_level} {material.rawmaterial_unit_name}</Badge>
                                <div className='d-block mt-1'>
                                    <Badge bg="danger" className='text-white fs-7 py-0 px-1'>Max - {material.maximum_stock_level} {material.rawmaterial_unit_name}</Badge>
                                </div>
                            </td>
                            <td>
                               <span className='px-2 py-1 rounded text-black fw-bold' style={{background: "#fde756d2"}}>
                                    ₹ {new Intl.NumberFormat('en-IN').format(material.base_cost)} /-
                                </span>

                            </td>
                            
                             <td>
                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                    <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        role="switch"
                                        checked={material.status == 0}
                                        onChange={() => handleRawMaterialStatusChange(material.sno, material.status)}
                                    />
                                </div>
                            </td> 
                            <td> 
                                <span class="text-end">
                                    <OverlayTrigger  trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1"  
                                        onClick={() => handleModalToggleView(material.sno)}
                                        >
                                            <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger  trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1"  
                                        onClick={() => handleModalToggleEdit(material.sno)}
                                        >
                                            <span><i class="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                     
                                </span>
                            </td>
                        </tr> 
                          ))
                            ) : (
                                <tr>
                                <td colSpan="9" className="text-center text-muted py-3">
                                    No raw materials found.
                                </td>
                                </tr>
                            )}
                    </tbody> */}

                    <tbody className="text-gray-600 fw-semibold fs-7">

    {loading ? (
        // ==== SKELETON ROWS ====
        [...Array(5)].map((_, index) => (
            <tr key={index}>
                <td><Skeleton height={40} /></td>
                <td><Skeleton height={40} /></td>
                <td><Skeleton height={40} /></td>
                <td><Skeleton height={40} /></td>
                <td><Skeleton height={40} /></td>
                <td><Skeleton height={40} /></td>
                <td><Skeleton height={40} /></td>
                <td><Skeleton height={40} /></td>
            </tr>
        ))
    ) : Array.isArray(rawMaterials) && rawMaterials.length > 0 ? (
        // ==== REAL DATA ROWS ====
        rawMaterials.map(material => (
            <tr key={material.sno}>
                <td>
                    <div className="d-flex align-items-center justify-content-start gap-2">
                        <LightGallery
                            onInit={onInit}
                            speed={500}
                            plugins={[lgThumbnail, lgZoom]}
                        >
                            <div data-src={material.image_url || raw} className='border rounded px-1 py-0'>
                                <img src={material.image_url || raw} alt="Basmathi Rice" className='cursor-pointer w-45px h-45px' />
                            </div>
                        </LightGallery>
                        <div>
                            <label className='text-black font-w400 fs-7'>{material.rawmaterial_name}</label>
                            <div className="d-block">
                                <label className="fs-8 text-dark">{material.rawmaterial_category_name}</label>
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <label className='text-black font-w400 fs-7'>
                        {material.brand_name || <span className="text-muted"> - </span>}
                    </label>
                    <div className='d-block mt-1'>
                        <Badge bg="info" className='text-white fs-7 py-0 px-1'>{material.expiry_period} Days</Badge>
                    </div>
                </td>

                <td className='text-center'>
                    <div className='d-flex flex-row gap-1'>
                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Packed GST</span></Tooltip>} >
                            <Badge bg="success" className='text-white fs-8 py-0 px-1'>{material.packed_gst_value || <span className="text-muted"> - </span>} %</Badge>
                        </OverlayTrigger>
                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Unpacked GST</span></Tooltip>} >
                            <Badge bg="secondary" className='text-white fs-8 py-0 px-1'>{material.unpacked_gst_value || <span className="text-muted"> - </span>} %</Badge>
                        </OverlayTrigger>
                    </div>
                </td>

                <td>
                    <label className='text-black font-w400 fs-7'>{material.rawmaterial_quantity} {material.rawmaterial_unit_name}</label>
                </td>

                <td>
                    <Badge bg="warning" className='text-white fs-7 py-0 px-1'>Min - {material.minimum_stock_level} {material.rawmaterial_unit_name}</Badge>
                    <div className='d-block mt-1'>
                        <Badge bg="danger" className='text-white fs-7 py-0 px-1'>Max - {material.maximum_stock_level} {material.rawmaterial_unit_name}</Badge>
                    </div>
                </td>

                <td>
                    <span className='px-2 py-1 rounded text-black fw-bold' style={{ background: "#fde756d2" }}>
                        ₹ {new Intl.NumberFormat('en-IN').format(material.base_cost)} /-
                    </span>
                </td>

                <td>
                    <div className="form-check form-switch d-flex align-items-center mb-3">
                        <input
                            className="form-check-input me-2"
                            type="checkbox"
                            role="switch"
                            checked={material.status == 0}
                            onChange={() => handleRawMaterialStatusChange(material.sno, material.status)}
                        />
                    </div>
                </td>

                <td>
                    <span className="text-end">
                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                            <Button variant="primary tp-btn-light px-2 py-1 me-1"
                                onClick={() => handleModalToggleView(material.sno)}>
                                <i className="fa fa-eye fs-6 mt-1"></i>
                            </Button>
                        </OverlayTrigger>

                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                            <Button variant="primary tp-btn-light px-2 py-1 me-1"
                                onClick={() => handleModalToggleEdit(material.sno)}>
                                <i className="fa-solid fa-pen-to-square fs-6 mt-1"></i>
                            </Button>
                        </OverlayTrigger>
                    </span>
                </td>
            </tr>
        ))
    ) : (
        // ==== NO DATA ====
        <tr>
            <td colSpan="9" className="text-center text-muted py-3">
                No raw materials found.
            </td>
        </tr>
    )}

                    </tbody>

                </table>

                <Raw_Material_Edit
                    show={showEditModal}
                    onClose={handleCloseModal}
                    rawmaterialId={rawmaterialIdToEdit}  // Pass the product ID (sno) to EditProduct modal
                    rawmaterialData={rawmaterialData}    // Pass product data to EditProduct (optional)
                     // Pass loading state to EditProduct
                />


                 {/*  For View(Start) */}
                        {open && modalType === "ViewRawMat" && viewRawMaterialDetails && (
                        <Raw_Material_View
                            show={open}
                            onClose={() => setOpen(false)}
                            data={viewRawMaterialDetails}
                        />
                        )}
        
                        {/*  For View(End) */}
                
                {/* <div className="d-flex justify-content-between align-items-center mt-3"> 
                    <div>
                        {rawMaterials.length > 0 && (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + rawMaterials.length} of {totalPages * perPage - (perPage - rawMaterials.length)} entries
                            </span>
                        )}
                    </div> 
                         <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}> 
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                        Previous
                                    </button>
                                </li>
 
                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                        1
                                    </button>
                                </li>
 
                                {page > 4 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}
 
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                .map(p => (
                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                            {p}
                                        </button>
                                    </li>
                                ))}
 
                                {page < totalPages - 3 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}
 
                                {totalPages > 1 && (
                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                    {totalPages}
                                    </button>
                                </li>
                                )}
 
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                    Next
                                </button>
                                </li>
                            </ul>
                        </nav>

                </div>
                                                            */}

                                                            {/* Pagination + Showing Count + Skeleton */}
   
                    <div className="d-flex justify-content-between align-items-center mt-3">

                        {/* LEFT SIDE (Show X to Y of Z Entries OR Skeleton) */}
                        <div>
                            {loading ? (
                                <div 
                                    style={{
                                        width: "180px",
                                        height: "12px",
                                        background: "#e0e0e0",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s infinite"
                                    }}
                                ></div>
                            ) : (
                                rawMaterials.length > 0 && (
                                    <span className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + rawMaterials.length} of {totalPages * perPage - (perPage - rawMaterials.length)} entries
                                    </span>
                                )
                            )}
                        </div>


                        {/* RIGHT SIDE PAGINATION OR SKELETON */}
                        {loading ? (
                            <div className="d-flex gap-2">
                                {Array.from({ length: 6 }).map((_, i) => (
                                    <div 
                                        key={i}
                                        style={{
                                            width: "32px",
                                            height: "24px",
                                            background: "#e0e0e0",
                                            borderRadius: "4px",
                                            animation: "pulse 1.5s infinite"
                                        }}
                                    ></div>
                                ))}
                            </div>
                        ) : (
                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: "0.75rem" }}>

                                    {/* Previous */}
                                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                        <button 
                                            className="page-link" 
                                            style={{ padding: "0.25rem 0.5rem" }} 
                                            onClick={() => setPage(page - 1)}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {/* First Page */}
                                    <li className={`page-item ${page === 1 ? "active" : ""}`}>
                                        <button 
                                            className="page-link" 
                                            style={{ padding: "0.25rem 0.5rem" }} 
                                            onClick={() => setPage(1)}
                                        >
                                            1
                                        </button>
                                    </li>

                                    {/* Left Ellipsis */}
                                    {page > 4 && (
                                        <li className="page-item disabled">
                                            <span className="page-link" style={{ padding: "0.25rem 0.5rem" }}>…</span>
                                        </li>
                                    )}

                                    {/* Pages Near Current Page */}
                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                        .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                        .map(p => (
                                            <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                                                <button 
                                                    className="page-link" 
                                                    style={{ padding: "0.25rem 0.5rem" }} 
                                                    onClick={() => setPage(p)}
                                                >
                                                    {p}
                                                </button>
                                            </li>
                                        ))}

                                    {/* Right Ellipsis */}
                                    {page < totalPages - 3 && (
                                        <li className="page-item disabled">
                                            <span className="page-link" style={{ padding: "0.25rem 0.5rem" }}>…</span>
                                        </li>
                                    )}

                                    {/* Last Page */}
                                    {totalPages > 1 && (
                                        <li className={`page-item ${page === totalPages ? "active" : ""}`}>
                                            <button 
                                                className="page-link" 
                                                style={{ padding: "0.25rem 0.5rem" }} 
                                                onClick={() => setPage(totalPages)}
                                            >
                                                {totalPages}
                                            </button>
                                        </li>
                                    )}

                                    {/* Next */}
                                    <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                                        <button 
                                            className="page-link" 
                                            style={{ padding: "0.25rem 0.5rem" }} 
                                            onClick={() => setPage(page + 1)}
                                        >
                                            Next
                                        </button>
                                    </li>

                                </ul>
                            </nav>
                        )}

                    </div>
            </div>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Raw Material Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Raw Material Category</label>
                                <Select
                                    defaultValue={raw_material_cat[0]}
                                    onChange={setSelectedOption}
                                    options={raw_material_cat}
                                    placeholder="Select Raw Material Category"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Raw Material</label>
                                <Select
                                    value={selectedOption}
                                    onChange={setSelectedOption}
                                    options={raw_material}
                                    placeholder="Select Raw Material Category"
                                />
                            </div> 
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker 
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY" 
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={onClose}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={onClose}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default RawMaterials;  